import React, { useContext, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import { signUpWithPassword } from '../supabase/supabase';
import { Button, Alert } from 'react-bootstrap';

function RegistrationForm() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isMissionaryEmail, setIsMissionaryEmail] = useState(false);
    const [confirmMissionaryEmail, setConfirmMissionaryEmail] = useState(false);
    const [errors, setErrors] = useState<string[]>([]);
    const [submitted, setSubmitted] = useState(false);

    const global = useContext(GlobalContext);

    const validate = () => {
        const v_errors: string[] = [];
        const regex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/;
        if (password.length < 8) {
            v_errors.push('Password must be at least 8 characters long.');
        }
        if (!regex.test(password)) {
            v_errors.push(
                'Password must contain at least one lowercase letter, one uppercase letter, one number, and one symbol.'
            );
        }
        if (isMissionaryEmail && !confirmMissionaryEmail) {
            v_errors.push('Please confirm that you want to use your missionary email.');
        }
        if (password !== confirmPassword) {
            v_errors.push('Passwords do not match.');
        }
        console.log(v_errors);
        setErrors(v_errors);
        return v_errors.length === 0; // Return true if no errors
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const isValid = validate();
        if (isValid) {
            const auth = await signUpWithPassword(email, password); // Pass user and missionary data to parent component
            global.setSession(auth.data.session);
            global.setUser(auth.data.user);
            setSubmitted(true);
        }
    };

    const checkEmail = (email: string) => {
        setEmail(email);
        const regex = /@missionary.org$/;
        setIsMissionaryEmail(regex.test(email));
    };

    return (
        <div className="modern-auth-form">
            {errors.length > 0 && (
                <Alert variant="danger" className="auth-error">
                    <ul className="error-list">
                        {errors.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                </Alert>
            )}
            
            {!submitted ? (
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="email"
                            id="email"
                            name="email"
                            autoComplete="email"
                            required
                            className="modern-input"
                            placeholder="Email address"
                            value={email}
                            onChange={(e) => checkEmail(e.target.value)}
                        />
                        {isMissionaryEmail && (
                            <div className="missionary-warning">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        id="confirmMissionaryEmail"
                                        checked={confirmMissionaryEmail}
                                        onChange={() => setConfirmMissionaryEmail(!confirmMissionaryEmail)}
                                        className="checkbox-input"
                                    />
                                    <span className="checkbox-text">
                                        I confirm I want to use my missionary email 
                                        (not recommended - <a href="/faq">learn why</a>)
                                    </span>
                                </label>
                            </div>
                        )}
                    </div>
                    
                    <div className="form-group">
                        <input
                            type="password"
                            id="password"
                            name="password"
                            autoComplete="new-password"
                            required
                            className="modern-input"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    
                    <div className="form-group">
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            autoComplete="new-password"
                            required
                            className="modern-input"
                            placeholder="Confirm password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>

                    <Button
                        type="submit"
                        className="modern-submit-btn"
                        size="lg"
                    >
                        Create Account
                    </Button>
                </form>
            ) : (
                <div className="success-message">
                    <h4>Check your email!</h4>
                    <p>We've sent you a confirmation link to complete your registration.</p>
                </div>
            )}
        </div>
    );
}

export default RegistrationForm;
